// extracted by mini-css-extract-plugin
export default {"root":"TableCell_root__WgkG-","head":"TableCell_head__nUztA"};